// A page for one game, show or event from catalog.ts (/games/<id>, /shows/<id>, /events/<id>): its picture, what it
// is, when and where, and the way in. Posting a show is adding an entry to the catalog; this page does the rest.
import { useAccount } from './account';
import { REG } from './brand';
import { KINDS, STATUS_LABEL, type Experience } from './catalog';
import { SiteFooter, SiteNav } from './Chrome';
import { openRegister } from './Register';
import { linkProps } from './router';
import './home.css';

const whenText = (iso: string) =>
  new Date(iso).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: '2-digit' }) + ' IST';

export function ExperiencePage({ e }: { e: Experience }) {
  const me = useAccount();
  const kind = KINDS.find((k) => k.kind === e.kind)!;
  return (
    <div className="gx kz">
      <div className="kz-grain" aria-hidden />
      <SiteNav />
      <main className="xp">
        <div className="xp-pic">{e.image ? <img src={e.image} alt={`${e.title}, inside the game`} /> : <div className="blank" />}</div>
        <div className="xp-body">
          <p className="gx-kicker mono">
            <a {...linkProps('/#stage')}>{kind.plural}</a> · <span className={`st-status ${e.status}`}>{STATUS_LABEL[e.status]}</span>
          </p>
          <h1>
            {e.title}
            <br />
            <em>{e.tagline}</em>
          </h1>
          <dl className="xp-facts mono">
            {e.when && (
              <div>
                <dt>When</dt>
                <dd>{whenText(e.when)}</dd>
              </div>
            )}
            {e.where && (
              <div>
                <dt>Where</dt>
                <dd>{e.where}</dd>
              </div>
            )}
            {e.host && (
              <div>
                <dt>By</dt>
                <dd>{e.host}</dd>
              </div>
            )}
          </dl>
          <p className="xp-blurb">{e.blurb}</p>
          <div className="xp-acts">
            {me?.claim ? (
              <a className="gx-btn lg" {...linkProps('/account')}>
                You’re on the waitlist · @{me.claim.name}
              </a>
            ) : (
              <button type="button" className="gx-btn lg" onClick={() => openRegister()}>
                Join the waitlist · ₹{REG.fee}
              </button>
            )}
            {e.kind === 'game' && (
              <a className="gx-btn ghost lg" {...linkProps(`/#${e.id}`)}>
                See it on the map
              </a>
            )}
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
